import { MultiDayShiftRowGroupInput } from './get-multi-day-shift-row-group-class.types';

export const getMultiDayShiftRowGroupClass = (
  rows: MultiDayShiftRowGroupInput[]
): Record<string, string> => {
  const classInRowIds: Record<string, string> = {};

  for (let index = 0; index < rows.length; index++) {
    const currentRow = rows[index];
    const previousRow = rows[index - 1];
    const nextRow = rows[index + 1];

    const currentGroupId = currentRow.multiDayShiftId;
    if (currentGroupId == null) {
      continue;
    }

    const previousInSameGroup = previousRow?.multiDayShiftId === currentGroupId;
    const nextInSameGroup = nextRow?.multiDayShiftId === currentGroupId;

    let rowClass = '';
    if (!previousInSameGroup && nextInSameGroup) {
      rowClass = 'row-group-first';
    } else if (previousInSameGroup && nextInSameGroup) {
      rowClass = 'row-group-middle';
    } else if (previousInSameGroup && !nextInSameGroup) {
      rowClass = 'row-group-last';
    } else if (!previousInSameGroup && !nextInSameGroup) {
      rowClass = 'row-group-single';
    }

    classInRowIds[currentRow.id] = rowClass;
  }

  return classInRowIds;
};
